<template>
  <div class="platform-connect" @scroll="onScroll">
    <div class="banner">
      <img src="../../assets//img/platform-connect/banner1.png" alt="">
    </div>
    <div
      class="platform-list"
      :style="{ margin: setMtop ? '450px 0 0' : '400px 0 0' }"
    >
      <div class="platform-item" @click="openWeb(0)">
        <div class="platform-type">
          <img
            src="../../assets//img/platform-connect/location-blue.png"
            alt=""
          >
          <p>国家平台</p>
        </div>
        <div class="platform-des">
          <img
            src="../../assets//img/platform-connect/logo-new.59a73b97.png"
            alt=""
          >
        </div>
      </div>

      <div class="platform-item" @click="openWeb(1)">
        <div class="platform-type">
          <img
            src="../../assets//img/platform-connect/location-red.png"
            alt=""
          >
          <p>省级平台</p>
        </div>
        <div class="platform-des">
          <img
            src="../../assets//img/platform-connect/koi_nmg_xxlogo.png"
            alt=""
          >
        </div>
      </div>

      <div class="platform-item" @click="openWeb(2)">
        <div class="platform-type">
          <img
            src="../../assets//img/platform-connect/location-orign.png"
            alt=""
          >
          <p>校车监管平台</p>
        </div>
        <div class="platform-des">
          <img
            src="../../assets//img/platform-connect/koi_nmg_xclogo.png"
            alt=""
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlatformConnect',
  data() {
    return {
      setMtop: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      if (document.documentElement.scrollTop >= 100) {
        this.setMtop = true;
      } else {
        this.setMtop = false;
      }
    },
    openWeb(type) {
      switch (type) {
        case 0:
          window.open('https://basic.smartedu.cn/');
          break;
        case 1:
          window.open('https://basic.nmg.smartedu.cn/');
          break;
        case 2:
          window.open('http://111.26.5.83:8088');
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.platform-connect {
  .banner {
    width: 100%;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    padding-top: 160px;
    text-align: center;
    height: 520px;
    background: rgb(41, 97, 215);

    img {
      width: 100%;
      height: 360px;
      object-fit: cover;
    }
  }

  .platform-list {
    width: 1200px;

    .platform-item {
      display: flex;
      align-items: center;
      margin: 0 0 22px;
      cursor: pointer;

      .platform-type {
        width: 248px;
        height: 167px;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 34px 0 0;

        img {
          width: 24px;
          margin: 0 0 26px;
        }

        p {
          font-size: 24px;
          color: #334eb4;
        }
      }

      .platform-des {
        width: 918px;
        height: 166px;
        background: #ffffff;
        display: flex;
        align-items: center;

        img {
          // height: 79px;
          margin: 0 0 0 43px;
          transition: all 0.3s ease-in;
        }
      }

      .platform-des:hover {
        img {
          transform: scale(1.02);
        }
      }
    }

    .platform-item:nth-child(2) {
      p {
        color: #329F89;
      }
    }

    .platform-item:nth-child(3) {
      p {
        color: #ffb000;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .platform-connect .banner {
    top:66px;
  }
}
</style>
